import {
  computed,
  Injectable,
  Pipe,
  PipeTransform,
  Signal,
} from '@angular/core';
import { select } from '@ngxs/store';
import { LocalizationState } from '../state/localization.state';
import { toLocalizedTimeDateFormat } from '../utils/localized-date-time-format';
import { BaseLocalizedPlaceholderFormatPipe } from './base-localized-placeholder-format.pipe';
import { BaseLocalizedDateTimeFormatParams } from './base-localized-date-time-format.pipe';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'localizedTimeDateFormat',
  standalone: true,
})
export class LocalizedTimeDateFormatPipe
  extends BaseLocalizedPlaceholderFormatPipe<BaseLocalizedDateTimeFormatParams>
  implements PipeTransform
{
  private readonly localizationSetting = select(
    LocalizationState.getLocalizationSetting,
  );

  private readonly dateFnsLocale = select(LocalizationState.getDateFnsLocale);
  transform(value: BaseLocalizedDateTimeFormatParams): string {
    if (!value) {
      return '';
    } else {
      return toLocalizedTimeDateFormat(
        value,
        this.localizationSetting(),
        this.dateFnsLocale(),
      );
    }
  }

  toFormattedSignal(value: BaseLocalizedDateTimeFormatParams): Signal<string> {
    return computed(() => this.transform(value));
  }
  protected getPlaceholderInput(): Date {
    return new Date();
  }
}
